import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import '@/index.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './config'
import { Toaster } from '@quest-lock/ui/sonner'
import { PostHogProvider } from 'posthog-js/react'
import { registerSW } from 'virtual:pwa-register'
import { toast } from 'sonner'

const updateSW = registerSW({
  onNeedRefresh() {
    if (import.meta.env.MODE === 'development') {
      window.location.reload()
    } else {
      toast('A new version is available', {
        description: 'Click to update now.',
        action: {
          label: 'Update',
          onClick: () => updateSW(true)
        },
        duration: 60000
      })
    }
  },
  onOfflineReady() {},
  immediate: import.meta.env.MODE === 'development'
})

const container = document.getElementById('root') as HTMLDivElement
const root = createRoot(container)
root.render(
  <StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        defaults: '2025-05-24',
        capture_exceptions: true,
        debug: import.meta.env.MODE === 'development',
        persistence: 'memory'
      }}
    >
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster />
      </QueryClientProvider>
    </PostHogProvider>
  </StrictMode>
)
